import React, { useState } from "react";
import { useScaleAudio } from "./hooks";
import { ScaleHeader, ScaleNotation, PlayButton, TechnicalId, NecklaceButton, NecklaceModal, PurchaseModal } from "./components";
import scaleNames from "./data/names.json";

const ScaleCard = ({ 
  scale, 
  scaleNumber, 
  scaleKey, 
  superscaleIndex, 
  mode, 
  isVisible = true,
  matchingPattern = null,
  onNecklaceToggle,
  isNecklaceExpanded = false
}) => {
  const scaleInfo = scaleNames[scaleKey];
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  
  // Extract all audio logic into custom hook
  const { isPlaying, currentPlayingNote, handleNoteClick, handlePlayScale } = useScaleAudio(
    scale, 
    scaleNumber
  );



  return (
    <div className={`scale-card ${!isVisible ? 'scale-card--hidden' : ''}`} data-scale-number={scaleNumber}>
      <div className="scale-card-content">
        <ScaleHeader 
          scaleNumber={scaleNumber} 
          scaleInfo={scaleInfo} 
        />
        
        <ScaleNotation 
          scale={scale} 
          onNoteClick={handleNoteClick}
          matchingPattern={matchingPattern}
        />
        
        <TechnicalId 
          superscaleIndex={superscaleIndex} 
          mode={mode} 
        />
        
        <div className="ux-buttons">
          <PlayButton 
            isPlaying={isPlaying} 
            onPlay={handlePlayScale} 
          />
          <NecklaceButton 
            isVisible={isNecklaceExpanded} 
            onToggle={onNecklaceToggle} 
          />
          <button 
            className="purchase-button-corner"
            title="Purchase this scale"
            onClick={() => setShowPurchaseModal(true)}
          >
            $
          </button>
        </div>
        
        {isNecklaceExpanded && (
          <NecklaceModal 
            scale={scale} 
            mode={mode} 
            superscaleIndex={superscaleIndex}
            scaleNumber={scaleNumber}
            onClose={onNecklaceToggle}
            onPlayScale={handlePlayScale}
            onPurchase={() => {
              onNecklaceToggle(); // Close necklace modal
              setShowPurchaseModal(true); // Open purchase modal
            }}
          />
        )}
        
        {showPurchaseModal && (
          <PurchaseModal
            scaleNumber={scaleNumber}
            scale={scale}
            superscaleIndex={superscaleIndex}
            mode={mode}
            onClose={() => setShowPurchaseModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default ScaleCard;